import { defineQuery, enterQuery, exitQuery } from "bitecs";
import { TinyPetsWorld } from "../TinyPetsWorld";
import { Howl, Howler } from "howler";
import { SoundComponent } from "../components/SoundComponent";
import { SoundLocation } from "../Sounds";

export const createSoundSystem = (
    world: TinyPetsWorld,
    config: {
        globalVolume?: number;
    }
): {
    soundSystem: (world: TinyPetsWorld) => TinyPetsWorld;
    onVolumeChange: (volume: number) => void;
} => {
    Howler.volume(config.globalVolume || 1);

    const sounds: { [eid: number]: Howl } = {};

    const entityQuery = defineQuery([SoundComponent]);
    const enteredQuery = enterQuery(entityQuery);
    const exitedQuery = exitQuery(entityQuery);

    return {
        soundSystem: (world: TinyPetsWorld) => {
            const playSound = (eid: number) => {
                if (sounds[eid]) {
                    sounds[eid].stop();
                }

                sounds[eid] = new Howl({
                    src: [
                        SoundLocation[SoundComponent.soundLocation[eid][0]],
                        SoundLocation[SoundComponent.soundLocation[eid][1]],
                        SoundLocation[SoundComponent.soundLocation[eid][2]],
                    ],
                    autoplay: SoundComponent.autoplay[eid] === 1,
                    loop: SoundComponent.loop[eid] === 1,
                    volume: SoundComponent.volume[eid],
                    mute: SoundComponent.mute[eid] === 1,
                    rate: SoundComponent.rate[eid],
                });

                sounds[eid].play();
            };

            const stopSound = (eid: number) => {
                if (sounds[eid]) {
                    // FIXME: this should not be a general fadeout but it is nice for the purring right now
                    sounds[eid].fade(sounds[eid].volume(), 0, 2000);
                }
            };

            enteredQuery(world).forEach(playSound);

            entityQuery(world)
                .filter((eid) => SoundComponent.dirty[eid])
                .forEach((eid) => {
                    playSound(eid);
                    SoundComponent.dirty[eid] = 0;
                });

            exitedQuery(world).forEach(stopSound);

            return world;
        },
        onVolumeChange: Howler.volume,
    };
};
